import i18n from '../../locales/index'
import restful from '@/store/vuex'
// import axios from 'axios'
// import { Message } from 'view-design'

const state = {
  ...restful.states('country_currency')
}

const getters = {
  ...restful.getters('country_currency')
}

const actions = {
  ...restful.actions('country_currencies', 'CONFIG'),
}

const mutations = {
  ...restful.mutations('country_currency')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
